import * as C from '../../constants';
import defaultState from './defaultState';

export default {

  [C.SKI_SCHOOL_RESET_STATE](state) {
    Object.assign(state, defaultState());
  },

  // region Seasons
  [C.SKI_SCHOOL_SEASONS_LOAD_PENDING](state) {
    state.seasons = {
      ...state.seasons,
      itemsLoading: true,
      itemsError: undefined,
    };
  },

  [C.SKI_SCHOOL_SEASONS_LOAD_FAILURE](state, payload) {
    state.seasons = {
      ...state.seasons,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_SCHOOL_SEASONS_LOAD_SUCCESS](state, payload) {
    state.seasons = {
      ...state.seasons,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },
  // endregion

  // region Season
  [C.SKI_SCHOOL_SEASON_LOAD_PENDING](state) {
    state.season = {
      ...state.season,
      itemsLoading: true,
      itemsError: undefined,
    };
  },

  [C.SKI_SCHOOL_SEASON_LOAD_FAILURE](state, payload) {
    state.season = {
      ...state.season,
      ...payload,
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SET_SEASON_PRICES_ITEMS](state, payload) {
    state.season.prices.items = payload;
  },

  [C.SKI_SCHOOL_SEASON_LOAD_SUCCESS](state, payload) {
    const seasonPayload = Object.assign({}, payload);
    const newSeasonItem = {
      ...state.season,
      ...Object.assign({}, state.season.newSeasonItem),
    };
    if (seasonPayload.prices) {
      newSeasonItem.prices.items = seasonPayload.prices;
      delete seasonPayload.prices;
    }

    if (payload.personCategories) {
      newSeasonItem.personCategories.items = Object.values(payload.personCategories);
      delete seasonPayload.personCategories;
    }

    if (seasonPayload.seasonLevels) {
      newSeasonItem.levels.items = Object.values(seasonPayload.seasonLevels);
      delete seasonPayload.seasonLevels;
    }

    if (seasonPayload.seasonAreas) {
      newSeasonItem.skiAreas.ids = Object.values(seasonPayload.seasonAreas);
      delete seasonPayload.seasonAreas;
    }
    const seasonItem = {
      ...newSeasonItem,
      ...seasonPayload,
    };
    state.season = {
      ...state.season,
      ...seasonItem,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_SCHOOL_SEASON_CREATE_PENDING](state) {
    state.season = {
      ...state.season,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_SEASON_CREATE_SUCCESS](state, payload) {
    state.season = {
      ...state.season,
      ...payload,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_SEASON_CREATE_FAILURE](state, payload) {
    state.season = {
      ...state.season,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_SEASON_SAVE_PENDING](state) {
    state.season = {
      ...state.season,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_SEASON_SAVE_SUCCESS](state, payload) {
    state.season = {
      ...state.season,
      ...payload,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_SEASON_SAVE_FAILURE](state, payload) {
    state.season = {
      ...state.season,
      saveLoading: false,
      saveError: payload,
    };
  },
  // endregion

  // region Suppliers
  [C.SKI_SUPPLIERS_LOAD_PENDING](state) {
    state.suppliers = {
      ...state.suppliers,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_SUPPLIERS_LOAD_SUCCESS](state, payload) {
    state.suppliers = {
      ...state.suppliers,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_SUPPLIERS_LOAD_FAILURE](state, payload) {
    state.suppliers = {
      ...state.suppliers,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_SCHOOL_SEASON_SET](state, payload) {
    state.season = {
      ...state.season,
      ...payload,
    };
  },
  // endregion

  // region Person Categories
  [C.SKI_SCHOOL_PERSON_CATEGORIES_LOAD_PENDING](state) {
    state.season.personCategories = {
      ...state.season.personCategories,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_SCHOOL_PERSON_CATEGORIES_LOAD_SUCCESS](state, payload) {
    state.season.personCategories = {
      ...state.season.personCategories,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_SCHOOL_PERSON_CATEGORIES_LOAD_FAILURE](state, payload) {
    state.season.personCategories = {
      ...state.season.personCategories,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_SCHOOL_PERSON_CATEGORY_ADD](state) {
    const newPersonCategory = Object.assign({}, state.season.personCategories.newItem);
    newPersonCategory.skiSchoolSeasonId = state.season.id;
    state.season.personCategories.items = [
      newPersonCategory,
      ...Object.values(state.season.personCategories.items),
    ];
  },

  [C.SKI_SCHOOL_PERSON_CATEGORIES_SET](state, payload) {
    const personCategoryItem = {
      ...Object.assign({}, payload.personCategoryItem),
      ...payload.params,
    };
    const items = Object.values(state.season.personCategories.items).map(
      personCategory => (
        personCategory.id === personCategoryItem.id ? personCategoryItem : personCategory
      ),
    );
    state.season.personCategories.items = {
      ...items,
    };
  },

  [C.SKI_SCHOOL_PERSON_CATEGORY_CREATE_PENDING](state) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PERSON_CATEGORY_CREATE_SUCCESS](state) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PERSON_CATEGORY_CREATE_FAILURE](state, payload) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_PERSON_CATEGORY_SAVE_PENDING](state) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PERSON_CATEGORY_SAVE_SUCCESS](state, payload) {
    const items = Object.values(state.season.personCategories.items)
      .map(personCategory => (personCategory.id === payload.id ? payload : personCategory));
    state.season.personCategories = {
      ...state.season.personCategories,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PERSON_CATEGORY_SAVE_FAILURE](state, payload) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_PERSON_CATEGORY_REMOVE_PENDING](state) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PERSON_CATEGORY_REMOVE_SUCCESS](state, payload) {
    const items = Object.values(state.season.personCategories.items)
      .filter(personCategory => personCategory.id !== payload);
    state.season.personCategories = {
      ...state.season.personCategories,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PERSON_CATEGORY_REMOVE_FAILURE](state, payload) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: false,
      saveError: payload,
    };
  },
  // endregion

  // region Ski School Areas
  [C.SKI_SCHOOL_AREAS_LOAD_PENDING](state) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_SCHOOL_AREAS_LOAD_SUCCESS](state, payload) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_SCHOOL_AREAS_LOAD_FAILURE](state, payload) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_SCHOOL_AREAS_SAVE_PENDING](state) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_AREAS_SAVE_SUCCESS](state, payload) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      items: payload,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_AREAS_SAVE_FAILURE](state) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_AREAS_DELETE_PENDING](state) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_AREAS_DELETE_SUCCESS](state, payload) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      items: payload,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_AREAS_DELETE_FAILURE](state) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      saveLoading: false,
      saveError: undefined,
    };
  },
  // endregion

  // region Sales Types
  [C.SKI_SCHOOL_SALES_TYPES_LOAD_PENDING](state) {
    state.salesTypes = {
      ...state.salesTypes,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_SCHOOL_SALES_TYPES_LOAD_SUCCESS](state, payload) {
    state.salesTypes = {
      ...state.salesTypes,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_SCHOOL_SALES_TYPES_LOAD_FAILURE](state, payload) {
    state.salesTypes = {
      ...state.salesTypes,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },
  // endregion

  // region Levels
  [C.SKI_SCHOOL_LEVELS_LOAD_PENDING](state) {
    state.season.levels = {
      ...state.season.levels,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_SCHOOL_LEVELS_LOAD_SUCCESS](state, payload) {
    state.season.levels = {
      ...state.season.levels,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_SCHOOL_LEVELS_LOAD_FAILURE](state, payload) {
    state.season.levels = {
      ...state.season.levels,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_SCHOOL_LEVEL_ADD](state) {
    const newPersonCategory = Object.assign({}, state.season.levels.newItem);
    newPersonCategory.skiSchoolSeasonId = state.season.id;
    state.season.levels.items = [
      newPersonCategory,
      ...Object.values(state.season.levels.items),
    ];
  },

  [C.SKI_SCHOOL_LEVELS_SET](state, payload) {
    const levelItem = {
      ...Object.assign({}, payload.levelItem),
      ...payload.params,
    };
    const items = Object.values(state.season.levels.items).map(
      level => (
        level.id === levelItem.id ? levelItem : level
      ),
    );
    state.season.levels.items = {
      ...items,
    };
  },

  [C.SKI_SCHOOL_LEVEL_CREATE_PENDING](state) {
    state.season.levels = {
      ...state.season.levels,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_LEVEL_CREATE_SUCCESS](state) {
    state.season.levels = {
      ...state.season.levels,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_LEVEL_CREATE_FAILURE](state, payload) {
    state.season.levels = {
      ...state.season.levels,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_LEVEL_SAVE_PENDING](state) {
    state.season.levels = {
      ...state.season.levels,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_LEVEL_SAVE_SUCCESS](state, payload) {
    const items = Object.values(state.season.levels.items)
      .map(level => (level.id === payload.id ? payload : level));
    state.season.levels = {
      ...state.season.levels,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_LEVEL_SAVE_FAILURE](state, payload) {
    state.season.levels = {
      ...state.season.levels,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_LEVEL_REMOVE_PENDING](state) {
    state.season.levels = {
      ...state.season.levels,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_LEVEL_REMOVE_SUCCESS](state, payload) {
    const items = Object.values(state.season.levels.items)
      .filter(level => level.id !== payload);
    state.season.levels = {
      ...state.season.levels,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_LEVEL_REMOVE_FAILURE](state, payload) {
    state.season.levels = {
      ...state.season.levels,
      saveLoading: false,
      saveError: payload,
    };
  },
  // endregion

  // region Lesson types
  [C.SKI_SCHOOL_LESSON_TYPES_LOAD_PENDING](state) {
    state.lessonTypes = {
      ...state.lessonTypes,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_SCHOOL_LESSON_TYPES_LOAD_SUCCESS](state, payload) {
    state.lessonTypes = {
      ...state.lessonTypes,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_SCHOOL_LESSON_TYPES_LOAD_FAILURE](state, payload) {
    state.lessonTypes = {
      ...state.lessonTypes,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },
  // endregion

  // region Ski Types
  [C.SKI_SCHOOL_SKI_TYPES_LOAD_PENDING](state) {
    state.skiTypes = {
      ...state.skiTypes,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_SCHOOL_SKI_TYPES_LOAD_SUCCESS](state, payload) {
    state.skiTypes = {
      ...state.skiTypes,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_SCHOOL_SKI_TYPES_LOAD_FAILURE](state, payload) {
    state.skiTypes = {
      ...state.skiTypes,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },
  // endregion

  // region Prices
  [C.SKI_SCHOOL_PRICES_LOAD_PENDING](state) {
    state.season.prices = {
      ...state.season.prices,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_SCHOOL_PRICES_LOAD_SUCCESS](state, payload) {
    const maxPriceId = Math.max.apply(
      null,
      Object.values(payload).map(item => item.id),
    );
    state.season.prices = {
      ...state.season.prices,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
      activePriceId: maxPriceId,
    };
  },

  [C.SKI_SCHOOL_PRICES_LOAD_FAILURE](state, payload) {
    state.season.prices = {
      ...state.season.prices,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_SCHOOL_PRICE_SET](state, payload) {
    const priceItem = {
      ...Object.assign({}, payload.price),
      ...payload.params,
    };
    const items = Object.values(state.season.prices.items).map(
      price => (
        price.id === priceItem.id ? priceItem : price
      ),
    );
    state.season.prices.items = {
      ...items,
    };
  },

  [C.SKI_SCHOOL_PRICE_ADD](state, items) {
    state.season.prices.items = {
      ...items,
    };
  },

  [C.SKI_SCHOOL_PRICE_CREATE_PENDING](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: true,
      saveError: undefined,
      activePriceId: undefined,
    };
  },

  [C.SKI_SCHOOL_PRICE_CREATE_SUCCESS](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: false,
      saveError: undefined,
      activePriceId: undefined,
    };
  },

  [C.SKI_SCHOOL_PRICE_CREATE_FAILURE](state, payload) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_PRICE_SAVE_PENDING](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PRICE_SAVE_SUCCESS](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PRICE_SAVE_FAILURE](state, payload) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_PRICE_REMOVE_PENDING](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PRICE_REMOVE_SUCCESS](state, priceId) {
    const items = Object.values(state.season.prices.items).filter(
      price => price.id !== priceId,
    );
    state.season.prices = {
      ...state.season.prices,
      items,
      saveLoading: false,
      saveError: undefined,
      activePriceId: undefined,
    };
  },

  [C.SKI_SCHOOL_PRICE_REMOVE_FAILURE](state, payload) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_PRICE_START_DAY_SAVE_PENDING](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PRICE_START_DAY_SAVE_SUCCESS](state, { priceId, weekdayNumber }) {
    const items = Object.values(state.season.prices.items).map((price) => {
      let priceStartDays = price.priceStartDays;
      if (price.id === priceId && priceStartDays.indexOf(weekdayNumber) < 0) {
        priceStartDays = [
          ...priceStartDays,
          weekdayNumber,
        ];
      }
      return {
        ...price,
        priceStartDays,
      };
    });
    state.season.prices = {
      ...state.season.prices,
      items,
      saveLoading: false,
      saveError: undefined,
      activePriceId: priceId,
    };
  },

  [C.SKI_SCHOOL_PRICE_START_DAY_SAVE_FAILURE](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PRICE_START_DAY_DELETE_PENDING](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PRICE_START_DAY_DELETE_SUCCESS](state, { priceId, weekdayNumber }) {
    const items = Object.values(state.season.prices.items).map((price) => {
      let priceStartDays = price.priceStartDays;
      if (price.id === priceId) {
        priceStartDays = [
          ...priceStartDays.filter(priceStartDayNumber => priceStartDayNumber !== weekdayNumber),
        ];
      }
      return {
        ...price,
        priceStartDays,
      };
    });
    state.season.prices = {
      ...state.season.prices,
      items,
      saveLoading: false,
      saveError: undefined,
      activePriceId: priceId,
    };
  },

  [C.SKI_SCHOOL_PRICE_START_DAY_DELETE_FAILURE](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PRICE_COMBINATION_SAVE_PENDING](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PRICE_COMBINATION_SAVE_SUCCESS](state, { priceId, newPriceCombination }) {
    const items = Object.values(state.season.prices.items).map((price) => {
      let priceCombinations = price.priceCombinations;
      if (price.id === priceId) {
        priceCombinations = [
          ...priceCombinations,
          newPriceCombination,
        ];
      }
      return {
        ...price,
        priceCombinations,
      };
    });
    state.season.prices = {
      ...state.season.prices,
      items,
      saveLoading: false,
      saveError: undefined,
      activePriceId: priceId,
    };
  },

  [C.SKI_SCHOOL_PRICE_COMBINATION_SAVE_FAILURE](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PRICE_COMBINATION_UPDATE_PENDING](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PRICE_COMBINATION_UPDATE_SUCCESS](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PRICE_COMBINATION_UPDATE_FAILURE](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PRICE_COMBINATION_DELETE_PENDING](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PRICE_COMBINATION_DELETE_SUCCESS](state, { priceId, priceCombinationId }) {
    const items = Object.values(state.season.prices.items).map((price) => {
      let priceCombinations = price.priceCombinations;
      if (price.id === priceId) {
        priceCombinations = [
          ...priceCombinations.filter(
            priceCombination => priceCombination.id !== priceCombinationId,
          ),
        ];
      }
      return {
        ...price,
        priceCombinations,
      };
    });
    state.season.prices = {
      ...state.season.prices,
      items,
      saveLoading: false,
      saveError: undefined,
      activePriceId: priceId,
    };
  },

  [C.SKI_SCHOOL_PRICE_COMBINATION_DELETE_FAILURE](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_SEASON_PICK_UP_PLACES_PENDING](state) {
    state.pickupPlaces = {
      ...state.pickupPlaces,
      loading: true,
      error: false,
      items: [],
    };
  },

  [C.SKI_SCHOOL_SEASON_PICK_UP_PLACES_SUCCESS](state, payload) {
    state.pickupPlaces = {
      ...state.pickupPlaces,
      loading: false,
      error: false,
      items: payload,
    };
  },

  [C.SKI_SCHOOL_SEASON_PICK_UP_PLACES_FAILURE](state) {
    state.pickupPlaces = {
      ...state.pickupPlaces,
      loading: false,
      error: true,
      items: [],
    };
  },

  [C.SKI_SCHOOL_SEASON_PICK_UP_PLACES_SET](state, payload) {
    state.pickupPlaces = {
      ...state.pickupPlaces,
      items: payload,
    };
  },

  // endregion
};



// WEBPACK FOOTER //
// ./src/store/modules/ski/school/mutations.js